(()=>{
  if(window.__faDeliveryObserverScopeShim)return;
  const NativeObserver=window.MutationObserver;
  if(!NativeObserver)return;

  window.__faDeliveryObserverScopeShim=1;
  window.__faDeliveryNativeMutationObserver=NativeObserver;

  class FaScopedMutationObserver extends NativeObserver{
    observe(target,options){
      if(target===document.documentElement&&options?.childList&&options?.subtree){
        const widget=document.querySelector('[data-fa-delivery-widget]');
        const scope=widget?.closest('product-info')||widget?.closest('.shopify-section')||document.querySelector('main[data-template="product"]')||target;
        return super.observe(scope,options);
      }
      return super.observe(target,options);
    }
  }

  window.MutationObserver=FaScopedMutationObserver;
})();
